import storage from 'redux-persist/lib/storage';
import immutablePersistenceTransform from '../shared/services/immutablePersistenceTransform';

export default {
  reducerVersion: '1.0',
  storeConfig: {
    key: 'primary',
    storage,
    whitelist: [],
    transforms: [immutablePersistenceTransform],
  },
};
